"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = exports.query = exports.namedQuery = exports.onSnapshotsInSync = exports.enableNetwork = exports.enableMultiTabIndexedDbPersistence = exports.enableIndexedDbPersistence = exports.disableNetwork = exports.connectFirestoreEmulator = exports.clearIndexedDbPersistence = exports.loadBundle = exports.initializeFirestore = exports.terminate = exports.getFirestore = exports.GeoPoint = exports.Timestamp = exports.getFirelord = void 0;
var firestore_1 = require("firebase/firestore");
var refs_1 = require("./refs");
/**
 Gets a FirelordReference instance that refers to the doc, collection, and collectionGroup at the specified absolute path.
 
 @param firestore
 Optional. A reference to the Firestore database. If no value is provided, default Firestore instance is used.
 
 @param path
 A slash-separated full path to a collection.
 
 @returns
 DocumentReference, CollectionReference and CollectionGroupReference instance.
 */
var getFirelord = function (firestore) {
    return function (collectionPath) {
        var fStore = firestore || (0, firestore_1.getFirestore)();
        var doc = (0, refs_1.docCreator)(fStore, collectionPath);
        var collection = (0, refs_1.collectionCreator)(fStore, collectionPath);
        var collectionGroup = (0, refs_1.collectionGroupCreator)(fStore, collectionPath.split('/').pop());
        return Object.freeze({
            doc: doc,
            collection: collection,
            collectionGroup: collectionGroup,
        });
    };
};
exports.getFirelord = getFirelord;
var firestore_2 = require("firebase/firestore");
Object.defineProperty(exports, "Timestamp", { enumerable: true, get: function () { return firestore_2.Timestamp; } });
Object.defineProperty(exports, "GeoPoint", { enumerable: true, get: function () { return firestore_2.GeoPoint; } });
Object.defineProperty(exports, "getFirestore", { enumerable: true, get: function () { return firestore_2.getFirestore; } });
Object.defineProperty(exports, "terminate", { enumerable: true, get: function () { return firestore_2.terminate; } });
Object.defineProperty(exports, "initializeFirestore", { enumerable: true, get: function () { return firestore_2.initializeFirestore; } });
Object.defineProperty(exports, "loadBundle", { enumerable: true, get: function () { return firestore_2.loadBundle; } });
Object.defineProperty(exports, "clearIndexedDbPersistence", { enumerable: true, get: function () { return firestore_2.clearIndexedDbPersistence; } });
Object.defineProperty(exports, "connectFirestoreEmulator", { enumerable: true, get: function () { return firestore_2.connectFirestoreEmulator; } });
Object.defineProperty(exports, "disableNetwork", { enumerable: true, get: function () { return firestore_2.disableNetwork; } });
Object.defineProperty(exports, "enableIndexedDbPersistence", { enumerable: true, get: function () { return firestore_2.enableIndexedDbPersistence; } });
Object.defineProperty(exports, "enableMultiTabIndexedDbPersistence", { enumerable: true, get: function () { return firestore_2.enableMultiTabIndexedDbPersistence; } });
Object.defineProperty(exports, "enableNetwork", { enumerable: true, get: function () { return firestore_2.enableNetwork; } });
Object.defineProperty(exports, "onSnapshotsInSync", { enumerable: true, get: function () { return firestore_2.onSnapshotsInSync; } });
Object.defineProperty(exports, "namedQuery", { enumerable: true, get: function () { return firestore_2.namedQuery; } });
__exportStar(require("./batch"), exports);
__exportStar(require("./transaction"), exports);
__exportStar(require("./fieldValue"), exports);
__exportStar(require("./fieldPath"), exports);
__exportStar(require("./onSnapshot"), exports);
__exportStar(require("./operations"), exports);
__exportStar(require("./queryClauses"), exports);
var refs_2 = require("./refs");
Object.defineProperty(exports, "query", { enumerable: true, get: function () { return refs_2.query; } });
__exportStar(require("./equal"), exports);
exports.Types = __importStar(require("./types"));
